import ProfileDropdown from './components/ProfileDropdown'
import LeftSideBarToggle from './components/LeftSideBarToggle'
import ThemeModeToggle from './components/ThemeModeToggle'

const TopBar = () => {
  return (
    <header className="topbar">
      <div className="container-fluid">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <LeftSideBarToggle />
          </div>
          <div className="d-flex align-items-center gap-1">
            <ThemeModeToggle />
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </header>
  )
}

export default TopBar
